import { makeStyles } from "tss-react/mui"
import { Outlet } from "react-router-dom"
import { Grid } from "@mui/material"
import { WellknownHeight } from "../../constants/wellknown"

const useStyles = makeStyles()((theme) => ({
    page: {
        // NOTE: We need the div to expand with the content in the x-direction
        // instead of default behavior of overflowing, since the background will
        // otherwise not fill the whole page
        width: "fit-content",
        // NOTE: We need to force the div to take up minimum 100% of parent when
        // using fit-content
        minWidth: "100%",

        height: "100%",
        minHeight: "100vh",

        backgroundColor: theme.palette.tailwind.slate[50],
    },
    container: {
        height: `calc(100% - ${WellknownHeight.PRIMARY_TOP_BAR}px)`,
    },
    contentGrid: {
        height: "100%",
    },
}))

export function LayoutWrapper() {
    const { classes } = useStyles()

    return (
        <div className={classes.page}>
            <Grid
                container
                direction="column"
                wrap="nowrap"
                justifyContent="space-between"
                className={classes.contentGrid}
            >
                <Grid item>
                    <Outlet />
                </Grid>
            </Grid>
        </div>
    )
}
